import { fatChainLengths } from '@constants/molecule'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinGame from './game'
import { FatChainLengthItem } from '@/services/store/interfaces'

@Component
export default class MixinFats extends mixins(MixinGame) {
  public fatGetTitle(chainLength: number, doubleBindings: number) {
    const fatChainLengthItem: FatChainLengthItem = fatChainLengths.find((item: FatChainLengthItem) => {
      return item.chainLength === chainLength &&
        item.doubleBindings === doubleBindings

    }) as FatChainLengthItem

    const cAmount: number = fatChainLengthItem.chainLength
    const doubleBinding: number = fatChainLengthItem.doubleBindings

    if (!cAmount) {
      return fatChainLengthItem.title
    }

    if (fatChainLengthItem.title === 'propionaat') {
      return fatChainLengthItem.title
    }

    return `${fatChainLengthItem.title} (C<sub>${cAmount}:${doubleBinding}</sub>)`
  }
}
